import { render, staticRenderFns } from "./LatestAssetList.vue?vue&type=template&id=b68963c4"
import script from "./LatestAssetList.vue?vue&type=script&lang=js"
export * from "./LatestAssetList.vue?vue&type=script&lang=js"
import style0 from "./LatestAssetList.vue?vue&type=style&index=0&id=b68963c4&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports